import { assign, cloneDeep, get } from 'lodash'
import moment from 'moment'

import { serverResponse } from 'app'
import Match from 'global-utils/models/sports/soccer/Match'

import * as pageActions from './MatchPageActions'

export default (state = pageActions.getInitialState(), action = {}) => {
  switch (action.type) {
    case pageActions.MATCH_APPROVE: {
      return state
    }
    case pageActions.MATCH_APPROVE_CANCELED: {
      return state
    }
    case pageActions.MATCH_APPROVE_ERROR: {
      return state
    }
    case pageActions.MATCH_APPROVE_FULFILLED:
    case pageActions.MATCH_DISAPPROVE_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)
      if (get(newState, 'data[0].id') === data.id) {
        data.local = newState.data[0].local
        data.visitor = newState.data[0].visitor
        newState.data[0] = new Match(assign(newState.data[0], data))
        return newState
      }
      return state
    }
    case pageActions.MATCH_AUDITS_FETCH: {
      return state
    }
    case pageActions.MATCH_AUDITS_FETCH_CANCELED: {
      return state
    }
    case pageActions.MATCH_AUDITS_FETCH_ERROR: {
      return state
    }
    case pageActions.MATCH_AUDITS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.audits = action.payload
      return newState
    }

    case pageActions.MATCH_DELETE: {
      return state
    }
    case pageActions.MATCH_DELETE_CANCELED: {
      return state
    }
    case pageActions.MATCH_DELETE_ERROR: {
      return state
    }
    case pageActions.MATCH_DELETE_FULFILLED: {
      if (state.data[0]) {
        const newState = cloneDeep(state)
        newState.data[0].ended_at = moment().unix()
        newState.data[0].approved_at = moment().unix()
        newState.data[0] = new Match(newState.data[0])
        return newState
      }
      return state
    }

    case pageActions.MATCH_DISAPPROVE: {
      return state
    }
    case pageActions.MATCH_DISAPPROVE_CANCELED: {
      return state
    }
    case pageActions.MATCH_DISAPPROVE_ERROR: {
      return state
    }

    case pageActions.MATCH_EVENTS_FETCH: {
      return {
        ...state,
        events: {
          ...state.events,
          loading: true,
        },
      }
    }
    case pageActions.MATCH_EVENTS_FETCH_CANCELED: {
      return {
        ...state,
        events: {
          ...state.events,
          loaded: false,
          loading: false,
        },
      }
    }
    case pageActions.MATCH_EVENTS_FETCH_ERROR: {
      const newState = {
        ...state,
        events: action.payload,
      }
      if (newState.data[0]) {
        newState.data[0].events = []
        newState.data[0] = new Match(newState.data[0])
      }
      return newState
    }
    case pageActions.MATCH_EVENTS_FETCH_FULFILLED: {
      const newState = {
        ...state,
        events: action.payload,
      }
      if (newState.data[0]) {
        newState.data[0].events = action.payload.data
        newState.data[0] = new Match(newState.data[0])
      }
      return newState
    }

    case pageActions.MATCH_EVENTS_REPORT: {
      return state
    }
    case pageActions.MATCH_EVENTS_REPORT_CANCELED: {
      return state
    }
    case pageActions.MATCH_EVENTS_REPORT_ERROR: {
      return state
    }
    case pageActions.MATCH_EVENTS_REPORT_FULFILLED: {
      const newState = cloneDeep(state)
      newState.data[0].reports = action.payload.data
      newState.data[0] = new Match(newState.data[0])
      return newState
    }

    case pageActions.MATCH_FAIR_PLAY_SET: {
      return state
    }
    case pageActions.MATCH_FAIR_PLAY_SET_CANCELED: {
      return state
    }
    case pageActions.MATCH_FAIR_PLAY_SET_ERROR: {
      return state
    }
    case pageActions.MATCH_FAIR_PLAY_SET_FULFILLED: {
      const newState = cloneDeep(state)
      newState.data[0].local_fair_play_points = get(action.payload, 'data.[0].local_fair_play_points')
      newState.data[0].visitor_fair_play_points = get(action.payload, 'data.[0].visitor_fair_play_points')
      newState.data[0] = new Match(newState.data[0])
      return newState
    }

    case pageActions.MATCH_FETCH: {
      return {
        ...pageActions.getInitialState(),
        key: action.payload.matchId,
        loaded: false,
        loading: true,
      }
    }
    case pageActions.MATCH_FETCH_CANCELED: {
      return {
        ...pageActions.getInitialState(),
        loaded: false,
        loading: false,
      }
    }
    case pageActions.MATCH_FETCH_ERROR: {
      return { ...state, error: action.payload, loaded: true, loading: false, posts: [] }
    }
    case pageActions.MATCH_FETCH_FULFILLED: {
      const newState = {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
      newState.data[0].events = newState.events.data
      newState.data[0].reports = newState.reports.data

      const liked = !!newState.like.data?.[0]?.like
      const team =
        newState.data[0].team === newState.data[0].local.id ? newState.data[0].local : newState.data[0].visitor

      if (liked) {
        team.liked = {
          liked: true,
        }
        team.following = {
          follow: true,
        }
        team.likes_count += 1
        team.follows_count += 1
      } else {
        team.liked = null
        team.following = null
        team.likes_count -= 1
        team.follows_count -= 1
      }

      newState.data[0] = new Match(newState.data[0])
      return newState
    }

    case pageActions.MATCH_LOCATION_SET: {
      return state
    }
    case pageActions.MATCH_LOCATION_SET_CANCELED: {
      return state
    }
    case pageActions.MATCH_LOCATION_SET_ERROR: {
      return state
    }
    case pageActions.MATCH_LOCATION_SET_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)
      if (get(newState, 'data[0].id') === data.id) {
        newState.data[0].location = data.location
        newState.data[0] = new Match(newState.data[0])
        return newState
      }
      return state
    }

    case pageActions.MATCH_LOCATIONS_FETCH: {
      return state
    }
    case pageActions.MATCH_LOCATIONS_FETCH_CANCELED: {
      return state
    }
    case pageActions.MATCH_LOCATIONS_FETCH_ERROR: {
      return state
    }
    case pageActions.MATCH_LOCATIONS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.data[0].locations = action.payload.data
      newState.data[0] = new Match(newState.data[0])
      return newState
    }

    case pageActions.MATCH_RATINGS_ADD: {
      return { ...state, ratings: serverResponse(state.ratings, { loading: true }) }
    }
    case pageActions.MATCH_RATINGS_ADD_CANCELED: {
      return { ...state, ratings: serverResponse() }
    }
    case pageActions.MATCH_RATINGS_ADD_ERROR: {
      return { ...state, ratings: serverResponse(state.ratings, { error: action.payload }) }
    }
    case pageActions.MATCH_RATINGS_ADD_FULFILLED: {
      return { ...state, ratings: serverResponse(action.payload, { loaded: true }) }
    }

    case pageActions.MATCH_RATINGS_FETCH: {
      return { ...state, ratings: serverResponse(state.ratings, { loading: true }) }
    }
    case pageActions.MATCH_RATINGS_FETCH_CANCELED: {
      return { ...state, ratings: serverResponse() }
    }
    case pageActions.MATCH_RATINGS_FETCH_ERROR: {
      return { ...state, ratings: serverResponse(state.ratings, { error: action.payload }) }
    }
    case pageActions.MATCH_RATINGS_FETCH_FULFILLED: {
      return { ...state, ratings: serverResponse(action.payload, { loaded: true }) }
    }

    case pageActions.MATCH_REFEREE_SET: {
      return state
    }
    case pageActions.MATCH_REFEREE_SET_CANCELED: {
      return state
    }
    case pageActions.MATCH_REFEREE_SET_ERROR: {
      return state
    }
    case pageActions.MATCH_REFEREE_SET_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)
      if (get(newState, 'data[0].id') === data.id) {
        newState.data[0].referee = data.referee
        newState.data[0] = new Match(newState.data[0])
        return newState
      }
      return state
    }

    case pageActions.MATCH_REFEREES_FETCH: {
      return state
    }
    case pageActions.MATCH_REFEREES_FETCH_CANCELED: {
      return state
    }
    case pageActions.MATCH_REFEREES_FETCH_ERROR: {
      return state
    }
    case pageActions.MATCH_REFEREES_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.data[0].referees = action.payload.data
      newState.data[0] = new Match(newState.data[0])
      return newState
    }

    case pageActions.MATCH_RELATION_FETCH: {
      return state
    }
    case pageActions.MATCH_RELATION_FETCH_CANCELED: {
      return state
    }
    case pageActions.MATCH_RELATION_FETCH_ERROR: {
      return state
    }
    case pageActions.MATCH_RELATION_FETCH_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)
      newState.data[0] = new Match(assign(newState.data[0], data))
      return newState
    }

    case pageActions.MATCH_REPORTS_DETAILS_FETCH: {
      return {
        ...state,
        reportsDetails: {
          ...state.reportsDetails,
          loaded: false,
          loading: true,
        },
      }
    }
    case pageActions.MATCH_REPORTS_DETAILS_FETCH_CANCELED: {
      return {
        ...state,
        reportsDetails: {
          ...state.reportsDetails,
          loaded: false,
          loading: false,
        },
      }
    }
    case pageActions.MATCH_REPORTS_DETAILS_FETCH_ERROR: {
      const newState = {
        ...state,
        reportsDetails: action.payload.response,
      }
      if (newState.data[0]) {
        newState.data[0].reportsDetails = []
        newState.data[0] = new Match(newState.data[0])
      }
      return newState
    }
    case pageActions.MATCH_REPORTS_DETAILS_FETCH_FULFILLED: {
      const newState = {
        ...state,
        reportsDetails: {
          ...action.payload,
          loaded: true,
        },
      }
      if (newState.data[0]) {
        newState.data[0].reportsDetails = action.payload.data
        newState.data[0] = new Match(newState.data[0])
      }
      return newState
    }

    case pageActions.MATCH_REPORTS_FETCH: {
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: true,
        },
      }
    }
    case pageActions.MATCH_REPORTS_FETCH_CANCELED: {
      return {
        ...state,
        reports: {
          ...state.reports,
          loaded: false,
          loading: false,
        },
      }
    }
    case pageActions.MATCH_REPORTS_FETCH_ERROR: {
      const newState = {
        ...state,
        reports: action.payload,
      }
      if (newState.data[0]) {
        newState.data[0].reports = []
        newState.data[0] = new Match(newState.data[0])
      }
      return newState
    }
    case pageActions.MATCH_REPORTS_FETCH_FULFILLED: {
      const newState = {
        ...state,
        reports: action.payload,
      }
      if (newState.data[0]) {
        newState.data[0].reports = action.payload.data
        newState.data[0] = new Match(newState.data[0])
      }
      return newState
    }

    case pageActions.MATCH_SCHEDULE: {
      return state
    }
    case pageActions.MATCH_SCHEDULE_CANCELED: {
      return state
    }
    case pageActions.MATCH_SCHEDULE_ERROR: {
      return state
    }
    case pageActions.MATCH_SCHEDULE_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)
      if (get(newState, 'data[0].id') === data.id) {
        newState.data[0].is_deferred = data.is_deferred
        newState.data[0].is_both_lose = data.is_both_lose
        newState.data[0].matched_at = data.matched_at
        newState.data[0].started_at = data.started_at
        newState.data[0].ended_at = data.ended_at
        newState.data[0] = new Match(newState.data[0])
        return newState
      }
      return state
    }

    case pageActions.MATCH_TEAM_LIKE: {
      return {
        ...state,
        like: {
          ...state.like,
          loading: true,
        },
      }
    }
    case pageActions.MATCH_TEAM_LIKE_CANCELED: {
      return {
        ...state,
        like: {
          ...state.like,
          loaded: false,
          loading: false,
        },
      }
    }
    case pageActions.MATCH_TEAM_LIKE_ERROR: {
      return {
        ...state,
        like: {
          ...pageActions.getInitialState().like,
          loaded: true,
        },
      }
    }
    case pageActions.MATCH_TEAM_LIKE_FULFILLED: {
      const newState = {
        ...state,
        like: {
          ...action.payload,
          loaded: true,
        },
      }
      if (newState.data[0]) {
        const stateMatch = newState.data[0]
        const newMatch = action.payload?.data?.[0] || {}
        const liked = newMatch.like
        const team = newMatch.team === stateMatch.local.id ? stateMatch.local : stateMatch.visitor

        if (liked) {
          team.liked = {
            liked: true,
          }
          team.following = {
            follow: true,
          }
          team.likes_count += 1
          team.follows_count += 1
        } else {
          team.liked = null
          team.following = null
          team.likes_count -= 1
          team.follows_count -= 1
        }
        newState.data[0] = new Match(stateMatch)
      }
      return newState
    }

    case pageActions.MATCH_TEAM_RELATION_FETCH: {
      return state
    }
    case pageActions.MATCH_TEAM_RELATION_FETCH_CANCELED: {
      return state
    }
    case pageActions.MATCH_TEAM_RELATION_FETCH_ERROR: {
      return state
    }
    case pageActions.MATCH_TEAM_RELATION_FETCH_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)

      if (newState.data[0] && newState.data[0].local && data.id === newState.data[0].local.id) {
        newState.data[0].local = assign(newState.data[0].local, data)
      } else if (newState.data[0] && newState.data[0].visitor && data.id === newState.data[0].visitor.id) {
        newState.data[0].visitor = assign(newState.data[0].visitor, data)
      }

      newState.data[0] = new Match(newState.data[0])
      return newState
    }

    default:
  }
  return state
}
